import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
//import saveAs from 'file-saver'
import { i18n } from '@/main.js'

const Actions = {
  // 一括請求書作成
  getCombinedBillFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .get(api.COMBINED_BILL, { params: params })
      .then((response) => {
        const path = mutationsTypes.LEDGER_SHEET_HEADER
        commit(path, response)
        return true
      })
      .catch((error) => {
        if (error.response.status) {
          alert(i18n.tc('common.common_combined-bill-permission-alert'))
        } else {
          commonUtil.afterApiFailProcess(error.response)
        }
        return false
      })
  },
  // 一括請求書一覧取得
  getCombinedBillListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .get(api.COMBINED_BILL_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.COMBINED_BILL_SET_COMBINED_BILL_LIST
        commit(path, response.data.data)

        const getData = getters.getCombinedBillListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // 一括請求書再ダウンロード
  getCombinedBillDownloadFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .get(api.COMBINED_BILL_DOWNLOAD, {
        responseType: 'blob', // バイナリデータとして取得
        params: params
      })
      .then((response) => {
        // 現在日時を取得してフォーマット
        const now = new Date();
        const formattedDate = `${now.getFullYear()}${String(
          now.getMonth() + 1
        ).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(
          now.getHours()
        ).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(
          now.getSeconds()
        ).padStart(2, '0')}`

        const fileName = 'combined-bill_' + formattedDate + '.pdf'

        // Blob を作成
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        })

        // ダウンロード用のリンクを作成
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName

        // リンクをクリックしてダウンロードを実行
        document.body.appendChild(link)
        link.click()

        // リンクを削除
        document.body.removeChild(link)

        return true // 成功時の戻り値
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
